module.exports = __webpack_public_path__ + "static/media/vision.a82381f6.jpg";